<h2 mat-dialog-title>View Comment</h2>
<button type="button" class="btn btn-link modal-close" (click)="cancel()">
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 6L6 18"
      stroke="#03101F"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 6L18 18"
      stroke="#03101F"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</button>
<mat-dialog-content>
  <div class="table-responsive tab-table school-detail-table px-3 mb-0">
   <table class="table table-hover"
     aria-describedby="This table describes the package information">
      <thead>
        <tr class="swap-header">
          <th class=""><span class="">S No</span></th>
          <th class=""><span class="">Comment</span></th>
          <th class=""><span class="">Commented By</span></th>
          <th>Date / Time</th>         
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let comment of comments; let i = index" class="px-2">
          <td class="fs-18 px-2 view-ticket-sno-td">
            <p class="mat-account-detail view-ticket-sno mb-0"> {{ i + 1 }} </p>
          </td>
          <td class="fs-18 px-2 view-ticket-comment-td">
            <p class="mat-account-detail view-ticket-comment mb-0" [matTooltip]="comment.comment">{{ comment.comment }}</p>
          </td>
          <td class="fs-18 px-2 view-ticket-date-td">
            <p class="mat-account-detail view-ticket-date mb-0" [matTooltip]="comment.userName"> {{ comment.userName }}</p>
           </td>
          <td class="fs-18 px-2 view-ticket-date-td">
            <p class="mat-account-detail view-ticket-date mb-0"> {{ comment.createdOn | date: 'dd-MM-yyyy / hh:mm a' }}</p>
           </td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>
